import { Home, Users, Calendar, Map, FileText, User2 } from 'lucide-react';
import type { LucideProps } from 'lucide-react';
import type { ComponentType } from 'react';

export interface NavItem {
  icon: ComponentType<LucideProps>;
  label: string;
  path: string;
  disabled?: boolean; // Added disabled property
  /** optional second-level links */
  children?: { label: string; path: string }[];
}

export const NAV_ITEMS: NavItem[] = [
  { icon: Home, label: 'Home', path: '/', disabled: true},
  { icon: Users, label: 'Clients', path: '/clients' },
  { icon: Calendar, label: 'Bookings', path: '/bookings', disabled: true },
  { icon: Map, label: 'Venues', path: '/user_venues', disabled: true },
  { icon: FileText, label: 'Invoices', path: '/invoices', disabled: true },
  {
    icon: User2,
    label: 'Profile',
    path: '/profile',
    children: [
      { label: 'Profile Info', path: '/profile' },          // default
      { label: 'Contract', path: '/profile/contract' },
      { label: 'Invoicing', path: '/profile/invoicing' },
    ]
  }
];

// Development-only navigation items (you can remove this in production)
// if (process.env.NODE_ENV === 'development') {
//   NAV_ITEMS.push({
//     icon: FileText,
//     label: 'Dev Test',
//     path: '/fee-schedule-test'
//   });
// }
